var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13217 23.2486C9.00651 23.2487 8.88235 23.2213 8.76841 23.1683C8.65448 23.1153 8.55353 23.038 8.47267 22.9418C8.39181 22.8456 8.33299 22.7329 8.30035 22.6115C8.26771 22.4902 8.26203 22.3632 8.28373 22.2394V22.2342L9.60139 14.9986H4.49998C4.35838 14.9986 4.21968 14.9585 4.09992 14.8829C3.98015 14.8074 3.88422 14.6995 3.82322 14.5717C3.76222 14.4439 3.73864 14.3015 3.75521 14.1608C3.77178 14.0202 3.82782 13.8871 3.91686 13.777L14.1905 1.07673C14.3074 0.928285 14.4697 0.82223 14.6526 0.774779C14.8356 0.727329 15.029 0.741095 15.2033 0.813972C15.3777 0.886849 15.5234 1.01483 15.6181 1.17833C15.7129 1.34184 15.7514 1.53188 15.7279 1.71938C15.728 1.73345 15.7242 1.74704 15.7219 1.7611L14.3995 8.9986H19.5C19.6416 8.99862 19.7803 9.03872 19.9 9.11427C20.0198 9.18981 20.1157 9.29772 20.1767 9.42551C20.2377 9.55329 20.2613 9.69574 20.2447 9.83637C20.2282 9.97699 20.1721 10.1101 20.0831 10.2202L9.80811 22.9205C9.72737 23.0225 9.62466 23.105 9.50763 23.1618C9.3906 23.2186 9.26226 23.2483 9.13217 23.2486Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/Flash.9845d144c1a2743be1a7061672cfb8c3.svg";
export { ForwardRef as ReactComponent };